import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ClientForm from "./pages/admin/ClientForm";
import ClientList from "./pages/admin/ClientList";
import ValveList from "./pages/admin/ValveList";
import ValveForm from "./pages/admin/ValveForm";
import CertificateForm from "./pages/admin/CertificateForm";
import CertificateList from "./pages/admin/CertificateList";
import ClientDashboard from "./pages/cliente/ClientDashboard";
import ClientValves from "./pages/cliente/ClientValves";
import ClientValveForm from "./pages/cliente/ClientValveForm";
import ClientCertificateList from "./pages/cliente/CertificateList";
import ClientCertificateForm from "./pages/cliente/CertificateForm";
import Login from "./pages/Login";
import Users from "./pages/admin/UserList";
import UserForm from "./pages/admin/UserForm";
import UserDetails from "./pages/admin/UserDetails";
import PrivateRoute from "./components/PrivateRoute";
import Documento from "./components/Documento";
import PublicCertificate from "./pages/PublicCertificate";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "'Urbanist', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
        },
      }}
    >
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to={"/login"} />} />
        <Route path="/pdf" element={<Documento />} />
        <Route path="/login" element={<Login />} />
        <Route path="/certificado/:id" element={<PublicCertificate />} />

        {/* Rotas do Admin */}
        <Route
          path="/admin/dashboard"
          element={<PrivateRoute element={<AdminDashboard />} allowedRoles={["admin"]} />}
        />

        {/* clientes */}
        <Route path="/admin/cadastro-cliente" element={<PrivateRoute element={<ClientForm />} allowedRoles={["admin"]} />} />
        <Route path="/admin/cadastro-cliente/:id" element={<PrivateRoute element={<ClientForm />} allowedRoles={["admin"]} />} />
        <Route path="/admin/clientes" element={<PrivateRoute element={<ClientList />} allowedRoles={["admin"]} />} />

        {/* valvulas */}
        <Route path="/admin/valvulas" element={<PrivateRoute element={<ValveList />} allowedRoles={["admin"]} />} />
        <Route path="/admin/cadastro-valvula" element={<PrivateRoute element={<ValveForm />} allowedRoles={["admin"]} />} />
        <Route
          path="/admin/cadastro-valvula/:tipo/:id"
          element={<PrivateRoute element={<ValveForm />} allowedRoles={["admin"]} />}
        />

        <Route path="/admin/usuarios" element={<PrivateRoute element={<Users />} allowedRoles={["admin"]} />} />
        <Route path="/admin/cadastro-usuario" element={<PrivateRoute element={<UserForm />} allowedRoles={["admin"]} />} />
        <Route path="/admin/cadastro-usuario/:id" element={<PrivateRoute element={<UserForm />} allowedRoles={["admin"]} />} />
        <Route path="/admin/usuario/:id" element={<PrivateRoute element={<UserDetails />} allowedRoles={["admin"]} />} />

        <Route path="/admin/certificados" element={<PrivateRoute element={<CertificateList />} allowedRoles={["admin"]} />} />
        <Route
          path="/admin/cadastro-certificado"
          element={<PrivateRoute element={<CertificateForm />} allowedRoles={["admin"]} />}
        />
        <Route
          path="/admin/cadastro-certificados/:id"
          element={<PrivateRoute element={<CertificateForm />} allowedRoles={["admin"]} />}
        />

        {/* Rotas do Cliente */}
        <Route path="/cliente/dashboard" element={<PrivateRoute element={<ClientDashboard />} allowedRoles={["cliente"]} />} />
        <Route path="/cliente/valvulas" element={<PrivateRoute element={<ClientValves />} allowedRoles={["cliente"]} />} />

        <Route
          path="/cliente/cadastro-valvula/:tipo/:id"
          element={<PrivateRoute element={<ClientValveForm />} allowedRoles={["cliente"]} />}
        />

        <Route
          path="/cliente/certificados"
          element={<PrivateRoute element={<ClientCertificateList />} allowedRoles={["cliente"]} />}
        />
        <Route
          path="/cliente/cadastro-certificados/:id"
          element={<PrivateRoute element={<ClientCertificateForm />} allowedRoles={["cliente"]} />}
        />

        {/* Rota 404 */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
    </ConfigProvider>
  );
}

export default App;
